import React from 'react';
import { FadeIn } from './FadeIn';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  alignment = 'center',
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-16 ${alignment === 'center' ? 'text-center mx-auto' : 'text-left'} ${className}`} data-id="element-288">
      <FadeIn direction="up" data-id="element-289">
        <div className={`flex items-center gap-4 mb-4 ${alignment === 'center' ? 'justify-center' : 'justify-start'}`} data-id="element-290">
          <div className="h-[1px] w-12 bg-gold/50" data-id="element-291"></div>
          <span className="text-gold tracking-[0.2em] uppercase text-sm font-medium" data-id="element-292">
            Libelle Estética
          </span>
          <div className="h-[1px] w-12 bg-gold/50" data-id="element-293"></div>
        </div>
      </FadeIn>

      <FadeIn direction="up" delay={0.1} data-id="element-294">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight" data-id="element-295">
          {title}
        </h2>
      </FadeIn>

      {subtitle && <FadeIn direction="up" delay={0.2} data-id="element-296">
          <p className="mt-6 text-lg md:text-xl max-w-2xl font-light leading-relaxed mx-auto text-[#8A8175]" data-id="element-297">
            {subtitle}
          </p>
        </FadeIn>}
    </div>;
}